import { onMount, onDestroy } from '@/modules/_'

export default function (element, dataset) {
  const wrap = element

  const els = gsap.utils.toArray('.aeo-window-card.is-fill', element)

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: 'top bottom',
      scrub: false,
      markers: false,
    },
    defaults: {
      duration: 0.8,
      ease: 'power2.out',
    },
  })

  tl.from(element, {
    autoAlpha: 0,
    y: 30,
  }).from(
    els,
    {
      autoAlpha: 0,
      duration: 0.15,
      stagger: {
        each: 0.1,
        start: 'center',
      },
    },
    '<0.25'
  )
}